import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  isOnFocus: false,
  writeName: "",
  noticeCommentIdx: "",
};

const noticeDetailSlice = createSlice({
  name: "noticeDetail",
  initialState,
  reducers: {
    setOnFocusReduce: (state, action: PayloadAction<boolean>) => {
      state.isOnFocus = action.payload;
    },
    setWriteNameReduce: (state, action: PayloadAction<Array<string>>) => {
      if (action.payload.length > 0) {
        state.writeName = action.payload[0];
        state.noticeCommentIdx = action.payload[1];
      }
    },
  },
});

export const { setOnFocusReduce, setWriteNameReduce } = noticeDetailSlice.actions;

export default noticeDetailSlice.reducer;
